<!--
 * @Descripttion: 
 * @Author: 陈文湘
 * @Date: 2020-07-01 17:28:46
 * @LastEditors: 陈文湘
 * @LastEditTime: 2020-07-18 10:38:25
 * @FilePath: \dzCloudc:\Users\Administrator\Documents\kuaio\src\App.vue
-->
<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view />
    <img src="./assets/img/nullnetwork.jpg" alt="" style="display:none" />
    <!-- <el-dialog :visible="visible" @close="close">
      测试弹窗
    </el-dialog> -->
    <contact ref="contact" class="contact" @click-toTop="toTop"></contact>
    <!-- <activityBanner
      ref="activityBanner"
      v-if="isActivityBanner"
      class="activityBanner"
    ></activityBanner> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import contact from "./components/contact/contact";
// import activityBanner from "./components/activityBanner/activityBanner";

export default {
  data() {
    return {
      hide: false,
    };
  },
  components: {
    contact,
    // activityBanner,
  },
  updated() {
    let screenHeight = window.screen.height;
    if (screenHeight <= 768) {
      $(".el-dialog").css({
        margin: "0 auto",
        transform: "scale(0.9)",
      });
    } else if (screenHeight > 768 && screenHeight <= 900) {
      $(".el-dialog").css({
        margin: "8vh auto 0",
        transform: "scale(0.9)",
      });
    }
  },
  mounted() {
    window.addEventListener("offline", () => {
      // 网络由正常到异常时触发
      sessionStorage.locationUrl = window.location.href;
      this.$router.replace("/networkError");
    });
    window.addEventListener("online", () => {
      window.location.href = sessionStorage.locationUrl;
    });
    window.addEventListener("scroll", this.copyViewScroll);
    this.$store.commit("checkThesTextFun");
  },
  created() {
    this.$store.commit("checkUserStatus");
  },
  computed: {
    ...mapState(["visible", "isActivityBanner"]),
  },
  methods: {
    close() {
      this.$store.commit("setVisible", false);
    },

    copyViewScroll() {
      let self = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // var offsetTop = document.querySelector("#copyBtn").offsetTop;
      if (scrollTop > 400) {
        self.$refs.contact.isToTop = true;
      } else {
        self.$refs.contact.isToTop = false;
      }
      // this.isConfirm = this.$refs.copyView.clientHeight - scrollTop < offsetTop;
    },
    /**
     * @name: toTop
     * @Description: 回到顶部
     * @param {}
     * @return:
     * @Author: 陈文湘
     */

    toTop() {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
  },
};
</script>

<style lang="scss">
@import url("./styles/reset.scss");
@import url("./styles/common.scss");
#app {
  // height: 100%;
  font-family: Microsoft YaHei UI;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.contact {
  position: fixed;
  right: 20px;
  bottom: 300px;
  z-index: 10;
}
.activityBanner {
  position: fixed;
  right: 50%;
  bottom: 0;
  transform: translate(50%, 0);
  z-index: 10;
}
</style>
